<template>
    <div>
        <main-header iconLeftBtn="el-icon-back" @onClickLeftBtn="onClickLeftBtn">
            <data-form
                :title="title"
                :sub_title="$t('change-phone.enter-new-phone')"
                :logo_src="require('@/assets/img/icon-change-phone.jpg')"
                show_logo
            >
                <div id="login-form">
                    <el-form
                        :model="numberValidateForm"
                        ref="numberValidateForm"
                        class="demo-ruleForm"
                        :rules="rules"
                    >
                        <el-form-item prop="PhoneNumber">
                            <span class="phone-input">{{
                                $t('change-phone.new-phone-number')
                            }}</span>
                            <el-input
                                id="PhoneNumber"
                                type="text"
                                inputmode="numeric"
                                v-model="numberValidateForm.PhoneNumber"
                                @keypress.native="onlyNumber($event)"
                                @focus="trackAuthentication(3)"
                                :placeholder="$t('login.input-phone')"
                                height="50"
                                autocomplete="off"
                            >
                                <el-select
                                    v-model="selectCountry"
                                    value-key="value"
                                    slot="prepend"
                                    placeholder="Select"
                                >
                                    <template slot="prefix">
                                        <img
                                            width="30"
                                            :height="
                                                selectCountry.value === 'IN' ||
                                                selectCountry.value === 'MM'
                                                    ? 26
                                                    : 30
                                            "
                                            style="margin-top: 5px"
                                            :src="
                                                require('@/assets/' +
                                                    selectCountry.src)
                                            "
                                            alt=""
                                        />
                                    </template>
                                    <el-option
                                        v-for="item in Country"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item"
                                    >
                                        <img
                                            width="30"
                                            :height="
                                                item.value === 'IN' ||
                                                item.value === 'MM'
                                                    ? 26
                                                    : 30
                                            "
                                            :src="require('@/assets/' + item.src)"
                                            alt=""
                                        />
                                        <label class="fs-al-t">{{
                                            item.label
                                        }}</label>
                                    </el-option>
                                </el-select>
                            </el-input>
                        </el-form-item>
                        <el-form-item class="mb-0">
                            <el-button
                                :loading="isLoading"
                                type="primary"
                                style="margin-top: -5px;"
                                class="submit-button d-flex justify-center align-center"
                                @click="authPhoneNumber('numberValidateForm')"
                            >
                                {{ $t('change-phone.continue') }}
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </data-form>
            <div class="space-screen" />
            <crm-dialog
                :visible="duplicatePhoneNumber"
                showClose
                removeCloseBtnSpace
                width="80%"
                @update:visible="closeDuplicateDialog"
                @close="closeDuplicateDialog"
            >
                <div class="d-flex justify-center align-center check-phone">
                    <img
                        :src="require('@/assets/svg/warning.svg?inline')"
                        width="120"
                        alt=""
                    />
                </div>
                <div class="dialog-topic">{{ $t('change-phone.check-again') }}</div>
                <div class="dialog-description">
                    {{ $t('change-phone.phone-duplicate') }}
                </div>
                <div class="dialog-button">
                    <el-button
                        type="primary"
                        class="confirm-button"
                        @click="closeDuplicateDialog"
                    >
                        {{ $t('change-phone.change-phone-title') }}
                    </el-button>
                </div>
            </crm-dialog>
            <WaterMark />
        </main-header>
    </div>
</template>

<script>
import DataForm from '@components/DataForm'
import { mapActions, mapGetters } from 'vuex'
import MainHeader from '@/components/MainHeader.vue'
import CrmDialog from '@/components/Dialog.vue'
import mixins from '@/helper/mixins'
import WaterMark from '@/components/WaterMark.vue'
import { AsYouType } from 'libphonenumber-js/mobile'
import GATracking from '@/helper/GATrackingMixins'
import TokenStorage from '@/store/storage/token.storage'

export default {
    components: {
        DataForm,
        CrmDialog,
        MainHeader,
        WaterMark,
    },
    mixins: [mixins, GATracking],
    data() {
        return {
            title: this.$t('change-phone.change-phone-title'),
            numberValidateForm: { PhoneNumber: '' },
            selectCountry: null,
            isLoading: false,
            duplicatePhoneNumber: false,
            Country: [
                {
                    value: 'TH',
                    label: 'Thailand',
                    src: 'icons/flag-thai.png',
                    length: 10,
                },
                {
                    value: 'LA',
                    label: 'Laos',
                    src: 'icons/flag-laos.png',
                    length: 11,
                },
                {
                    value: 'AU',
                    label: 'Australia',
                    src: 'icons/flag-aus.png',
                    length: 10,
                },
                {
                    value: 'DE',
                    label: 'Germany',
                    src: 'icons/flag-ger.png',
                    length: 11,
                },
                {
                    value: 'IN',
                    label: 'India',
                    src: 'icons/flag-india.png',
                    length: 10,
                },
                {
                    value: 'MM',
                    label: 'Myanmar',
                    src: 'icons/flag-myanmar.png',
                    length: 11,
                },
            ],
            rules: {
                PhoneNumber: [
                    {
                        required: true,
                        message: '* ' + this.$t('login.please-input-phone'),
                        trigger: 'blur',
                    },
                    { validator: this.validatePhoneNumber, trigger: 'change' },
                ],
            },
        }
    },
    computed: {
        ...mapGetters({
            restaurantInfo: 'restaurant/restaurantInfo',
            restaurantUUID: 'restaurant/restaurantUUID',
        }),
    },
    created() {
        this.selectCountry = this.Country[0]
    },
    methods: {
        ...mapActions({
            checkPhoneNumber: 'auth/checkPhoneNumber',
            sendVerifyHandler: 'user/sendVerifyHandler',
        }),
        closeDuplicateDialog() {
            this.duplicatePhoneNumber = false
            this.numberValidateForm = { PhoneNumber: '' }
        },
        onClickLeftBtn() {
            this.$router.push({
                name: 'Profile',
            })
        },
        async authPhoneNumber() {
            this.isLoading = true
            await this.$refs['numberValidateForm'].validate(async valid => {
                if (!valid) {
                    this.isLoading = false
                    return false
                }

                const asYouTypePhone = new AsYouType(this.selectCountry.value)
                asYouTypePhone.input(this.numberValidateForm.PhoneNumber)
                const {
                    countryCallingCode,
                    nationalNumber,
                } = asYouTypePhone.getNumber()

                const payload = {
                    restaurantAlias: this.restaurantInfo.restaurantUUID,
                    PhoneNumberRef1: `0${nationalNumber}`,
                    recaptchaToken: TokenStorage.recaptchaToken,
                    phoneCountryCode: countryCallingCode,
                }

                await this.checkPhoneNumber(payload)
                    .then(async isHavePhoneNumber => {
                        if (!isHavePhoneNumber) {
                            const {
                                restaurantAlias: restaurantUUID,
                                PhoneNumberRef1: phoneNumber,
                                ...params
                            } = payload
                            await this.sendVerifyHandler({
                                ...params,
                                restaurantUUID,
                                phoneNumber,
                            }).then(response => {
                                const { refCode } = response
                                this.$router.push({
                                    name: 'OTPChangePhone',
                                    query: {
                                        phoneNumber: payload.PhoneNumberRef1,
                                        phoneCountryCode:
                                            payload.phoneCountryCode,
                                        refCode,
                                        phoneNumberFormatted: asYouTypePhone.formattedOutput.replaceAll(
                                            ' ',
                                            '-',
                                        ),
                                    },
                                })
                            })
                        } else {
                            this.duplicatePhoneNumber = true
                        }
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            })
        },
        onlyNumber(evt) {
            evt = evt ? evt : window.event
            var charCode = evt.which ? evt.which : evt.keyCode
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                evt.preventDefault()
            } else {
                return true
            }
        },
        validatePhoneNumber(rule, value, callback) {
            clearTimeout(this.timerValidatePhoneNumber)

            if (!value) callback()

            const asYouTypePhone = new AsYouType(this.selectCountry.value)
            asYouTypePhone.input(value)

            if (asYouTypePhone.isValid() === false) {
                this.timerValidatePhoneNumber = setTimeout(() => {
                    callback(
                        new Error('* ' + this.$t('login.wrong-phone-format')),
                    )
                }, 1000)
            } else {
                callback()
            }
        },
    },
    watch: {
        selectCountry(val, preVal) {
            if (val && preVal != null) {
                this.trackAuthentication(2)
            }
        },
    },
}
</script>

<style scoped>
#login-form {
    font-size: 16px;
    margin-top: 15px;
}

#login-form #input-password.el-form-item {
    margin-bottom: 0px;
}

.register-text-buttom {
    margin-top: 12px;
    font-size: 20px;
    height: 24px;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0em;
    color: var(--gray-1);
}

.register-text-link {
    cursor: pointer;
    margin-left: 7px;
    font-weight: bold;
    font-size: 20px;
    line-height: 16px;
    color: var(--primary);
    text-decoration: none;
}

.submit-button {
    font-family: 'DB Heavent';
    font-weight: bold;
    font-size: 20px;
    margin-top: 21px;
    width: 100%;
    height: 44px;
}

.label-forget {
    text-align: right;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 26px;
    color: var(--primary);
}

.label-error {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    padding-bottom: 6px;
}

.space-screen {
    height: 30px;
}

/* Overide Phone Number */

.el-select-dropdown__item {
    padding: 0 10px;
}

.el-select-dropdown__item label {
    margin-left: 5px;
}

.el-select-dropdown__item.selected {
    font-weight: 400;
}
.el-input__prefix {
    display: flex;
    justify-content: center;
    align-items: center;
}
.el-input-group__append,
.el-input-group__prepend {
    background: #fefefe;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
    background: rgba(40, 183, 255, 0.12);
}
.item-center {
    display: flex;
    align-items: center;
}
.el-divider {
    background-color: #cfd0d1;
}
.el-divider__text.is-center {
    color: #dfe1e6;
}

.phone-input {
    font-size: 16px;
    line-height: 26px;
}

.confirm-button {
    width: 100%;
    font-family: 'DB Heavent';
    font-weight: 700;
    font-size: 20px;
}
</style>
